import Request from "./Request";

export default {
  getPatient(idObj) {
    const params = { column: Object.keys(idObj), value: idObj.id };

    const url = "patient/getEach?";

    return Request.get_data(url, params);
  },
  getByIndexCode(params) {
    const url = "patient/getByIndexCode?";

    return Request.get_data(url, params);
  },
  getPatients(params) {
    const url = "patient/get?";

    return Request.get_data(url, params);
  },
  createPatient(payload) {
    const url = "patient/store";

    return Request.post_data(url, payload);
  },
  updatePatient(payload) {
    const params = { id: payload.id };
    const url = "patient/update?";

    return Request.post_data(url, payload, params);
  },
  deletePatient(payload) {
    const url = "patient/delete";

    return Request.post_data(url, payload);
  },
};
